import { defineStore } from 'pinia'
import * as DataService from '@/DataService.js'
import dayjs from 'dayjs';

export const useGeneralStore = defineStore('general', {
    state: () => ({
        showMobile: false,
        adamDoes: null,
        getNext: null,
        lastPath: null,
        loading: false,
        mbbTeams: [],
        musicPlayer: {
            playerState: "closed",
            currentTime: "0:00",
            currentTrack: {
                title: "",
                description: "",
                last_modified: "",
                duration: 0,
            },
        },
        playing: false,
        // theme related
        containerClass: "relative mx-auto w-full pb-4 px-1 lg:px-4 rounded-md",
        headerClass:  "header mb-4 mt-4 text-4xl w-full font-header text-slate-600 font-bold text-center",
        subheaderClass: "font-header text-lg text-slate-200 text-center",
        subsubheaderClass: "mb-4 mt-6 text-xl uppercase text-gray-600 text-center",
        pillClass: 'cursor-pointer mr-1 pt-2 pb-1 p-1 px-6 bg-amber-400/80 hover:bg-amber-500',
        bbSectionHeader: 'text-2xl text-slate-900 col-span-4 pl-1',
        headerLink: 'text-4xl',
        screenWidth: document.body.clientWidth,
        screenHeight: document.body.clientHeight,
        // data
        birds: [],
        overrideTrack: null,
        latestBirds: [],
        latestBirdsUpdate: null,
        rareBirds: [],
        lastMusic: [],
        movies: [],
        music: [],
        newmovies: [],
        pastshows: [],
        recipes: [],
        shows: [],
        menuOut: true,
        pastShows: [],
        showChartNameDataset: [],
        showChartYearDataset: [],
        showChartVenueDataset: [],
        selectedConference: {},
        toptv: [],
        conferenceOnly: localStorage.getItem('conferenceOnlySchedule') ? localStorage.getItem('conferenceOnlySchedule') : false,
        playlist: []
    }),
    actions: {
        pullData() {
            this.getBirds();
            this.getShows();
            // this.getTeams();
        },
        getBirds() {
            DataService.client.get('get-all-birds')
            .then(b => {
                this.birds=b.data;
                this.getRareBirds();
            });
        },
        getRareBirds() {
            DataService.client.get('get-rare-detections')
            .then(b => {
                this.rareBirds=b.data;
                this.getLatestBirds();
            })
        },
        getLatestBirds() {
            DataService.client.get('get-latest-birds')
            .then(b => {
                this.latestBirds=b.data;
            })
        },
        getShows() {
            DataService.client.get(`shows/future`)
            .then((response) => {
                this.shows = response.data;
            })
        },
        getPlaylist() {
            if(this.playlist.length) return;
            DataService.client.get('player/playlist')
            .then((response) => {
                this.playlist = response.data;
            })
        },
        // getTeams() {
        //     if(!this.mbbTeams) {
        //     DataService.client.get(`bb-conference-teams/${this.selectedConference}`).then((d) => {
        //             this.mbbTeams=d.data;


        //         }
        //     )
        // }
        // },
        teamToNCAA(team){
            switch(team.toUpperCase()) {
                case 'ALBNY':
                    return 'ALBANY';
                case 'MASLOW':
                    return 'UMASSL';
                case 'BING':
                    return 'BINGHA';
                case 'VERM':
                    return 'VERMNT';
                case 'NHAMP':
                    return 'UNH';
                case 'NJIT':
                    return 'NJIT';
                case 'BRYANT':
                    return 'BRYANT';
                case 'MAINE':
                    return 'MAINE';
                case 'UMBC':
                    return 'UMBC';
                //njit umbc bryant maine
                default:
                    return false;
            }
        },
        formatDate(d, format='YYYY-MM-DD') {
            return dayjs(d, 'YYYY-MM-DD HH:mm:ss').format(format);
        },
        urlify(u) {
            if(!u) return null;
            u=u.replaceAll(" ","-");
            u=u.replaceAll("''","");
            return u.toLowerCase();
        },
        updateLatestBird(b) {
            this.latestBirds.push(b);
        },
        setItem(name, value) {
            localStorage.setItem(name, value);
            return value;
        },
        getItem(name, value) {
            return localStorage.getItem(name) ? localStorage.getItem(name) : null;
        }
    }
});
